module.exports = __webpack_public_path__ + "img/yiliao.4989f200.png";